<template>
    <div>
        <div class="orderhead">
                <div style="margin-left:2%">
                    已选目标疾病:
                    <span v-for=" (item,i) in selectedpkgs"  :label="item.label"
                                    :value="item.value"
                                    :key="item.value">
                                    
    <span  v-if="i===selectedpkgs.length-1">    {{ item.PackName }}</span>
      <span  v-if="i!=selectedpkgs.length-1">   {{ item.PackName+' ,' }}</span> 
                   
        </span>
                </div>
                
        </div>
      
        <div class="orderframe">
            <div class="orderhead">
                <div style="margin-left:5%">
                目标疾病项目清单
                </div>
            </div>
            <div style="padding:0 20px">
                <el-table :data="itemlist"  show-summary :summary-method="getSummaries" >
					<el-table-column type="index" label="序号" width="80%"  />
                    <el-tooltip content="Bottom center" placement="bottom" effect="light">
                    <el-table-column label="项目名称"  width="150%">
                        <template slot-scope="scope">
                       {{ getG(scope.row).GNAME }}
                        </template>
                    </el-table-column>
                    </el-tooltip>
                   <!--  <el-table-column label="检查意义" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ getG(scope.row).GRemarks }}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="价格(元)" align="right"  >
                        <template slot-scope="scope">
                            {{ getG(scope.row).GPrice}}
                        </template>
                    </el-table-column>
                </el-table>
                
            </div>
        </div>
	    <div class="orderframe">
            <div class="orderhead">
                <div style="margin-left:5%">
                单选项目清单
                </div>
            </div>
            <div style="padding:0 20px">
                <el-table :data="MItemlist"  show-summary :summary-method="getSummaries" >
					<el-table-column type="index" label="序号" width="80%" />
                    <el-table-column label="项目名称" width="150%">
                        <template slot-scope="scope">
                            {{ getG(scope.row).GNAME }}
                        </template>
                    </el-table-column>
                  <!--   <el-table-column label="检查意义" show-overflow-tooltip>
                        <template slot-scope="scope">
                            {{ getG(scope.row).GRemarks }}
                        </template>
                    </el-table-column> -->
                    <el-table-column label="价格(元)" align="right" >
                        <template slot-scope="scope">
                            {{ getG(scope.row).GPrice }}
                        </template>
                    </el-table-column>
                </el-table>
              
				
            </div>
        </div>
         
        <div class="ordermony">
                <div style="margin-left:5%">
                <el-row>
                        <el-col :span="6">折后价格{{discount}}元</el-col>
                        <el-col :span="6">服务费{{this.user.FuWuFei}}元</el-col>
                        <el-col :span="6">额定金额{{parseFloat(this.user.FixedQuota).toFixed(2)}}元</el-col>
                        <el-col :span="6">应收金额{{yingfu}}元</el-col>
                </el-row>
                </div>
                
        </div>
              
        <div style="text-align:center;margin-bottom:60px;    padding-top:26px;">
            <router-link to="/Monoidal"><el-button type="warning"  roundButton="true" style="margin-right:20px">上一步</el-button></router-link>
            <el-button type="primary" @click="cost" :disabled="!hasselected()"  v-loading.fullscreen.lock="fullscreenLoading">确定</el-button>
            
        </div>
    </div>
</template>

<script>
    import {restbase} from '../rest';
    import {foowwLocalStorage} from '../rest';
    export default {
        name: 'order',
        data() {
            return {
                itemlist: [],
                MItemlist: [],
                dialogTableVisible: false,
                isPrimary:true,
                Rdiscount:0,
                pklist:[],
                user:[],//用户信息
                selectedpkgs:[],//已选包
                ft2:[],//基表2项目
                Mgids:[],
                admin:[],//登录账户信息
                MinNum:0,
                yingfu:0,
                textarea:'',
                  user:[],
                  fullscreenLoading:false

            }
        },
           created(){
            //页面加载前执行 获取用户信息
           if (this.user.length == 0) {
              this.user=JSON.parse(foowwLocalStorage.get('user'));
              this.MinNum=this.user.MinNum;
              console.log(this.user);
              
            }

           this.ft2= JSON.parse(foowwLocalStorage.get('ft2'));//获取所有基表2项目
           this.relation=JSON.parse(sessionStorage.getItem('relation')); //获取所有关系

           this.selectedpkgs=JSON.parse(sessionStorage.getItem('selectedpkgs')); 
           this.Mgids=JSON.parse(sessionStorage.getItem('Mgids')); 
          
        },
        mounted() {
            this.selectedpkgs.forEach(pkg => {
                pkg.GIDs.forEach(g => {
                    if (this.itemlist.indexOf(g) === -1) {
                        this.itemlist.push(g)
                    }
                    
                if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(150)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 150), 1);
                }
                  if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(149)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 149), 1);
                }
                if(this.itemlist.indexOf(540)>0 && this.itemlist.indexOf(287)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 287), 1);
                }
                  if(this.itemlist.indexOf(149)>0 && this.itemlist.indexOf(150)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 150), 1);
                }
                 if(this.itemlist.indexOf(149)>0 && this.itemlist.indexOf(287)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 287), 1);
                }
                 if(this.itemlist.indexOf(82)>0 && this.itemlist.indexOf(79)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 82), 1);
                }
                  if(this.itemlist.indexOf(6)>0 && this.itemlist.indexOf(32)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 6), 1);
                }
                   if(this.itemlist.indexOf(558)>0 && this.itemlist.indexOf(560)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 558), 1);
                }
                   if(this.itemlist.indexOf(559)>0 && this.itemlist.indexOf(560)>0){
                    this.itemlist.splice(this.itemlist.findIndex(item => item === 559), 1);
                }
                });
                
                    if (this.pklist.indexOf(pkg.PKID) === -1) {
                        this.pklist.push(pkg.PKID)
                    }
                   
			
                    
            });
            
            this.MItemlist=this.Mgids;
              this.itemlist.forEach(element => {
                if(this.MItemlist.indexOf(element)>=0){
                    console.log(this.MItemlist);
                  this.MItemlist.splice(this.MItemlist.indexOf(element),1);
                  
                }
            });
		

                //排出包中互斥的单项
             this.relation.forEach(r => {
               if (this.itemlist.indexOf(r.Gid)>=0) 
                  { 

                    for(var i=0;i<this.MItemlist.length;i++){
                     if (r.ExclusionID!=null) 
                     {
                        var ExclusionID=r.ExclusionID.split(',');
                        if(ExclusionID.indexOf(this.MItemlist[i]+"")>=0)
                        {
                         var i=this.MItemlist.indexOf(this.MItemlist[i]);
                         this.MItemlist.splice(i--,1);//非常重要，删除指定坐标后，数组改变
                        }
                    }
                    }
                  
                  }
                 })
            
        },
        methods: {
            getTds(TSID) {
                let alltds=JSON.parse(sessionStorage.getItem('selectedpkgs'));
                return alltds.find(v=>{
                    return v.TSID === TSID;
                });
            },
           
            getG(GID) {
                return this.ft2.find(v=>{
                    return v.Gid === GID;
                });
            },
            getSummaries(param ) {
                const { columns, data } = param;
                columns;
                const s = data.reduce((prev, item) => this.getG(item).GPrice + prev, 0);
                const sums = [];
                sums[0]= '合计';
                sums[2] = s ;
                return sums;
            },
            cost() {
                
               
                if(this.yingfu<parseInt(this.MinNum)&&parseInt(this.user.FixedQuota)==0){
                    
                        this.$alert('抱歉，我们的最低定制额度是'+parseInt(this.MinNum)+'元！', '错误', {
                            customClass:"msgBox",
                        confirmButtonText: '确定',
                        center:true
                         });
                        return;
                }
                
                   this.$confirm('您确定完成该定制吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center:true,
          type: 'warning'
        }).then(() => {
             this.fullscreenLoading = true;
                const PKIDs = this.selectedpkgs.map(item => item.PKID);
                console.log(this.Rdiscount);
                   this.isPrimary=false;
                   const total=Math.max(parseInt(this.Rdiscount) +parseInt(this.user.FuWuFei)).toFixed(2);
                   let msg='';
                    if (this.itemlist.indexOf(270)>0 || this.itemlist.indexOf(274)>0 || this.MItemlist.indexOf(270)>0 || this.MItemlist.indexOf(274)>0)
                    {
                       msg+=' 您的体检产品包含2个及以上签证，需要您联系您的客户经理帮您完成预约。';
                    }
                     if (this.itemlist.indexOf(40)>0 || this.MItemlist.indexOf(40)>0)
                    {
                       msg+=' 您的体检产品包含餐后2小时血糖，建议您预约最早时间段的体检报到。';
                    }
               this.$http.post(restbase() + "asp/Order_user", {
                    SFZH: this.user.PaperValue,
                    PackIDs: PKIDs,
                    IDs:this.itemlist,
                    MIDs:this.MItemlist,
                    contact:this.user.ContactID,
                    TotalPrice:total,
                    YingshouPrice:this.yingfu

                }).then((response) => {
                    console.log(response);
                    const r = JSON.parse(response.data.d);
                    var qzcode=r.qzcode;
                     this.fullscreenLoading = false;
                    if (r.code !== '0') {
                        this.$notify.error({
                            title: '错误',
                            message: r.description
                        });
                    } else {
               
                        this.$alert('定制已成功！'+msg+'您的签证号码：'+qzcode, '温馨提示', {
                            customClass:"msgBox",
                            confirmButtonText: '确定',
                            center: true,
                            callback: action => {
                                //清空前一个人的定制数据
                                //清除session
                                sessionStorage.clear();
                                this.$router.push('/');
                             }
                          });
                    this.isPrimary=false;
                    }
                }, (response) => {
                    console.log(response);
                }).catch((response) => {
                    console.log(response);
                });
              }).catch(() => { });   
            },
            hasselected() {
				return this.isPrimary;	
            },
         
 
           formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]))
            },
           accMul(arg1, arg2) {
	var m = 0, s1 = arg1.toString(), s2 = arg2.toString();
	try { m += s1.split(".")[1].length } catch (e) { }
	try { m += s2.split(".")[1].length } catch (e) { }

	return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m);
            },
  
       
        },
        computed: {
            discount() {
                 let DPrice=0;
                    //特殊处理CT,不参与折扣this.itemlist.indexOf(540)>=0 ||
                 
                 if(this.itemlist.indexOf(540)>=0 || this.MItemlist.indexOf(540)>=0){
                    DPrice= this.getG(540).GPrice;
                }
                console.log(DPrice);
                const s = this.itemlist.reduce((prev, item) => this.getG(item).GPrice + prev, 0);
                const ms = this.MItemlist.reduce((prev, item) => this.getG(item).GPrice + prev, 0);
               //this.Rdiscount=Math.round(this.accMul((s+ms-DPrice), this.user.Discount))+DPrice;
                this.Rdiscount=Math.max(this.accMul((s+ms-DPrice), this.user.Discount)+DPrice,0).toFixed(2);
                this.yingfu=Math.max(this.Rdiscount - parseInt(this.user.FixedQuota)+parseInt(this.user.FuWuFei),0).toFixed(2);
                return this.Rdiscount;
            }
        }
    }
</script>

<style>
  .msgBox{
  width: 60%;
  }
    .orderframe {
        margin:0 auto;
        width:100%;
        padding-bottom:26px;
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
        border-radius: 4px;
        box-shadow: 2px 2px 2px #888;
        background-color: white;
        margin-bottom: 20px;
    }
    .orderhead {
        width:100%;
        height:100%;
        line-height:48px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
        margin-bottom: 20px;
    }
     .ordermony {
         margin:0 auto;
        width:100%;
        padding-bottom:26px;
        height:100%;
        line-height:30px;
        padding:0;
        color:white;
        background-color:#80A0D0;
        border-radius:4px 4px 0 0;
        margin-bottom: 20px;
        margin-top: 20px;
    }
</style>
